<template>
<div class="price-card">
  <van-image class="price-cover" fit="cover" 
  :error-icon="$placeImg"
  :loading-icon="$placeImg"
  :src="cardData.cover_mobile" alt=""></van-image>
  <div class="price-msg">
    <div class="price-name ellipsis">{{ cardData.name }}</div>
    <div class="price-des ellipsis">有效期{{ cardData.option_names }}</div>
    <div class="price">¥ {{ cardData.price }}</div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
  },
  computed: {},
  data() {
    return {};
  },
  onLoad() {},
  methods: {},
};
</script>

<style scoped>
.price-card {
  width: 100%;
  height: 167px;
  margin-bottom: 26px;
  display: flex;
  padding: 0 30px;
  box-sizing: border-box;
}

.price-card:last-of-type {
  margin-bottom: 0;
}

.price-cover {
  width: 200px;
  height: 200px;
  border-radius: 12px;
  display: block;
  flex: 0 1 200px;
  margin-right: 26px;
  overflow: hidden;
}

.price-msg {
  height: 200px;
  flex: 0 1 375px;
  display: flex;
  align-items: flex-start;
  ;
  justify-content: center;
  flex-direction: column;
  width: 375px;
}

.price-name {
  font-size: 32px;
  color: #333;
  font-weight: 600;
  width: 100%;
  margin-bottom: 10px;
}

.price-des {
  font-size: 28px;
  color: #666;
  font-weight: 400;
  width: 100%;
  margin-bottom: 20px;
  line-height: 1.5;
}

.price {
  font-size: 24px;
  color: #ff4d41;
  font-weight: 600;
}
</style>>
